import React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Copyright } from '../../components/KhCopytight/Copyright';

import { signInUser } from '../../services/AuthService/AuthServices';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

import { useNavigate } from 'react-router-dom';
import { Alert, CircularProgress } from '@mui/material';
import { getLocalStorageData } from '../../utils/LocalStorage';
import { setAccessToken } from './reducers/AuthSlice';

const defaultTheme = createTheme();

export default function SignIn() {
  const dispatch = useAppDispatch();

  const status = useAppSelector((state)=> state.Auth.status)
  const response = useAppSelector((state)=> state.Auth.data)
  const sessionToken = response?.accessKey
  const error = response?.error
  
  React.useEffect(() => {
    dispatch(setAccessToken(sessionToken as string))
  }, [dispatch, sessionToken])
  

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    dispatch(signInUser(data)) ;
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              id="LoginId"
              label="Login Id"
              name="LoginId"
              margin="normal"
              required
              fullWidth
              autoFocus
            />
            <TextField
              id="Password"
              name="Password"
              label="Password"
              type="password"
              margin="normal"
              required
              fullWidth
            />
            {
              status == 'failed' ? <Alert severity='error' >{error}</Alert> : null
            }
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              fullWidth
            >
              { status === 'loading' ? <CircularProgress /> : "Sign In"}
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="/password/reset" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright  sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}